function WorkerIcon({ color = '959FAF', size = '19', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M18.5148 8V7.9H18.4148H17.3264H17.2264V8V15.2C17.2264 15.3356 17.1774 15.4639 17.0929 15.5571C17.0087 15.6499 16.8967 15.7 16.7822 15.7H2.63264C2.51815 15.7 2.40612 15.6499 2.32189 15.5571C2.23737 15.4639 2.18843 15.3356 2.18843 15.2V8V7.9H2.08843H1H0.9V8V15.2C0.9 15.7009 1.0804 16.1831 1.40412 16.54C1.72813 16.8972 2.16979 17.1 2.63264 17.1H16.7822C17.245 17.1 17.6867 16.8972 18.0107 16.54C18.3344 16.1831 18.5148 15.7009 18.5148 15.2V8Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
      <path
        d="M18.4442 8.48335L18.5148 8.46164V8.38777V5.39449C18.5148 4.87272 18.3353 4.36995 18.0122 3.99726C17.6887 3.62412 17.2467 3.41114 16.7822 3.41114H13.0727V2.88335C13.0727 2.36158 12.8931 1.85881 12.5701 1.48612C12.2466 1.11298 11.8046 0.9 11.34 0.9H8.07476C7.61026 0.9 7.16822 1.11298 6.84475 1.48612C6.52168 1.85881 6.34213 2.36158 6.34213 2.88335V3.41114H2.63264C2.16813 3.41114 1.72609 3.62412 1.40263 3.99726C1.07955 4.36995 0.9 4.87272 0.9 5.39449V8.38777V8.46164L0.970603 8.48335L9.25787 11.0322L9.25791 11.0322C9.55233 11.1226 9.86247 11.1226 10.1569 11.0322L10.1569 11.0322L18.4442 8.48335ZM11.7843 3.41114H7.63055V2.88335C7.63055 2.73913 7.68035 2.60319 7.76551 2.50495C7.85028 2.40715 7.96194 2.35557 8.07476 2.35557H11.34C11.4529 2.35557 11.5645 2.40715 11.6493 2.50495C11.7345 2.60319 11.7843 2.73913 11.7843 2.88335V3.41114ZM9.59644 9.62813L9.59639 9.62811L2.18843 7.34963V5.39449C2.18843 5.25027 2.23822 5.11433 2.32338 5.01608C2.40816 4.91829 2.51981 4.86671 2.63264 4.86671H16.7822C16.895 4.86671 17.0066 4.91829 17.0914 5.01608C17.1766 5.11432 17.2264 5.25027 17.2264 5.39449V7.34963L9.81841 9.62811L9.81837 9.62813C9.74556 9.65055 9.66925 9.65055 9.59644 9.62813Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
    </svg>
  );
}

export default WorkerIcon;
